import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Header,
  Showcase,
  SectionTitle,
  Intro,
} from '../../../../components'

import data from './data.json'

export default props => {
  const toggleAccordion = accordionNumber => {
    document
      .getElementsByClassName('c-accordion__closed')
      [accordionNumber].classList.toggle('c-accordion__open')
    document
      .getElementsByClassName('c-accordion__header-icon')
      [accordionNumber].classList.toggle('icon--plus-sign')
    document
      .getElementsByClassName('c-accordion__header-icon')
      [accordionNumber].classList.toggle('icon--minus-sign')
    document
      .getElementsByClassName('c-accordion__header-title')
      [accordionNumber].classList.toggle('c-accordion__header-title--open')
  }

  const code = null

  return (
    <>
      <Header
        title={data.title}
        site={data.site}
        state="design"
        slug={data.slug + '/design/'}
        exclusive={true}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Accordions are a vertically stacked list of headers that toggle the
            display of related sections of content.
          </p>
          <p>
            Accordions can decrease cognitive load by grouping information and
            only presenting content that the user has selected. However, given
            their purpose, there is an inherent risk that users will miss
            information within the accordion. Do not use this component if it is
            crucial or required that a user review the content under all
            accordion headers.
          </p>
        </Intro>
        <SectionTitle>Usage</SectionTitle>

        {/* <Showcase site={data.site}
          title="Accordion Panel"
          text="Accordions decrease cognitive load by grouping information and
            only presenting content that the user has selected to view. However, given
            their purpose, there is an inherent risk that users will miss
            information within the accordion. Do not use this component if it is
            crucial or required that a user review the content under all
            accordion headers."
          code={code}
        >
          <div class="c-accordion">
            <button
              class="c-accordion__header-button"
              aria-expanded="false"
              onClick={() => toggleAccordion(0)}
            >
              <span class="c-accordion__header-title">Accordion Header</span>
              <div class="c-accordion__header-icon-container">
                <i class="icon icon--plus-sign c-accordion__header-icon"></i>
              </div>
            </button>
            <div class="c-accordion__closed" role="region">
              <div class="c-accordion__content">
                <p class="c-text-content">Related body content</p>
              </div>
            </div>
          </div>
        </Showcase> */}

        <Showcase
          site={data.site}
          title="Accordion"
          text="Accordions are presented by default in the collapsed state. Their header titles are black and the plus icon indicates that their is additional information available to view. When selected, accordions will change to their open state in which the header titles become primary green and the icon changes to a minus sign to toggle hiding that panel's content."
          code={code}
        >
          <div className="c-accordion-group">
            <div className="c-accordion">
              <button
                className="c-accordion__header-button"
                aria-expanded="false"
                onClick={() => toggleAccordion(0)}
              >
                <span className="c-accordion__header-title">
                  Accordion Header
                </span>
                <div className="c-accordion__header-icon-container">
                  <i className="icon icon--plus-sign c-accordion__header-icon"></i>
                </div>
              </button>
              <div className="c-accordion__closed" role="region">
                <div className="c-accordion__content">
                  <p className="c-text-content">Related body content</p>
                </div>
              </div>
            </div>
            <div className="c-accordion">
              <button
                className="c-accordion__header-button"
                aria-expanded="false"
                onClick={() => toggleAccordion(1)}
              >
                <span className="c-accordion__header-title">
                  Accordion Header
                </span>
                <div className="c-accordion__header-icon-container">
                  <i className="icon icon--plus-sign c-accordion__header-icon"></i>
                </div>
              </button>
              <div className="c-accordion__closed" role="region">
                <div className="c-accordion__content">
                  <p className="c-text-content">Related body content</p>
                </div>
              </div>
            </div>
            <div className="c-accordion">
              <button
                className="c-accordion__header-button"
                aria-expanded="false"
                onClick={() => toggleAccordion(2)}
              >
                <span className="c-accordion__header-title">
                  Accordion Header
                </span>
                <div className="c-accordion__header-icon-container">
                  <i className="icon icon--plus-sign c-accordion__header-icon"></i>
                </div>
              </button>
              <div className="c-accordion__closed" role="region">
                <div className="c-accordion__content">
                  <p className="c-text-content">Related body content</p>
                </div>
              </div>
            </div>
          </div>
        </Showcase>

        <SectionTitle>Design Environment</SectionTitle>
        <p>
          The accordion is best used in environments where there are space
          constraints, such as on mobile or within side panels. They are also
          used as an alternative to other content grouping components, such as{' '}
          <Link
            className="link"
            to={'/' + data.site + '/components/tabs/design'}
          >
            tabs
          </Link>
          , at smaller breakpoints to avoid side scroll. Keep a margin of at
          least 16px between the top of the accordion and any components above
          and below it. Accordions fill the width of their containing element.
        </p>

        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Accordion headers should clearly summarize the information in the
          panel. They should be succinct and fit onto one line. Follow the
          microcopy guidelines in the Title element for more information.
        </p>
      </Layout>
    </>
  )
}
